import React from "react";
import { useSelector } from "react-redux";
import { selectActiveLicense } from "../../../store/auth-slice";
import styles from "./PharmacistInfo.module.scss";

const PharmacistInfo = () => {
  const activeLicense = useSelector(selectActiveLicense);

  // Don't render if no active license
  if (!activeLicense) {
    return null;
  }

  // Find the first card image (isCardImage: true)
  const cardImage = activeLicense.images?.find((img) => img.isCardImage);
  const imageSrc = cardImage?.imageLink
    ? `${process.env.REACT_APP_CDN_PATH}license_images/${cardImage.imageLink}`
    : null;

  // Generate initials from name as fallback
  const initials = `${activeLicense.licenseUserFirstName?.charAt(0) || ""}${
    activeLicense.licenseUserSecondName?.charAt(0) || ""
  }`.toUpperCase();

  return (
    <div
      className={styles.PharmacistInfo}
      role="status"
      aria-label={`Aktivan farmaceut: ${activeLicense.licenseUserFirstName} ${activeLicense.licenseUserSecondName}`}
    >
      {/* Avatar */}
      <div className={styles.Avatar} aria-hidden="true">
        {imageSrc ? (
          <img
            src={imageSrc}
            alt=""
            className={styles.AvatarImage}
            onError={(e) => {
              // Fallback to initials if image fails to load
              e.currentTarget.style.display = "none";
              const parent = e.currentTarget.parentElement;
              if (parent) {
                parent.classList.add(styles.AvatarInitials);
                parent.textContent = initials;
              }
            }}
          />
        ) : (
          <span className={styles.AvatarInitials}>{initials}</span>
        )}
      </div>

      {/* Name and License */}
      <div className={styles.InfoText}>
        <div className={styles.Name}>
          {activeLicense.licenseUserFirstName}{" "}
          {activeLicense.licenseUserSecondName}
        </div>
        <div className={styles.LicenseCode}>{activeLicense.licenseCode}</div>
      </div>
    </div>
  );
};

export default PharmacistInfo;
